<template>
  <div class="order-stat">
    <!-- 统计卡片 -->
    <div class="stats-cards">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon total">
              <i class="el-icon-s-order"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ statistics.totalOrders || 0 }}</div>
              <div class="stats-label">订单总数</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon paid">
              <i class="el-icon-success"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ statistics.paidOrders || 0 }}</div>
              <div class="stats-label">已付款订单</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon amount">
              <i class="el-icon-money"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ formatAmount(statistics.totalAmount || 0) }}</div>
              <div class="stats-label">总销售额</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <div class="stats-card">
            <div class="stats-icon paid-amount">
              <i class="el-icon-wallet"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ formatAmount(statistics.paidAmount || 0) }}</div>
              <div class="stats-label">已付款金额</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">订单号：</span>
            <el-input v-model="searchInfo.orderNo" clearable placeholder="请输入订单号"></el-input>
          </div>
          <div class="search-item">
            <span class="label">订单状态：</span>
            <el-select v-model="searchInfo.status" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in statusList" :key="i" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">买家ID：</span>
            <el-input v-model="searchInfo.buyerId" clearable placeholder="请输入买家ID"></el-input>
          </div>
          <div class="search-item">
            <span class="label">卖家ID：</span>
            <el-input v-model="searchInfo.sellerId" clearable placeholder="请输入卖家ID"></el-input>
          </div>
          <div class="search-item">
            <span class="label">商品ID：</span>
            <el-input v-model="searchInfo.productId" clearable placeholder="请输入商品ID"></el-input>
          </div>
          <div class="search-item date-picker">
            <span class="label">创建时间：</span>
            <el-date-picker v-model="searchDateArr" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-refresh" @click="refreshStats">刷新统计</el-button>
      </div>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" max-height="600px" @row-dblclick="handleRowDblClick">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="coverImage" label="商品图片" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.coverImage" style="position: relative; display: inline-block;">
              <el-image
                      :src="parseImages(scope.row.coverImage)[0]"
                      :preview-src-list="parseImages(scope.row.coverImage)"
                      style="width: 60px; height: 60px; border-radius: 4px;"
                      fit="cover"
              />
              <span v-if="parseImages(scope.row.coverImage).length > 1"
                    style="position: absolute; bottom: 2px; right: 2px; background: rgba(0,0,0,0.6); color: #fff; padding: 0 4px; font-size: 10px; border-radius: 2px;">
                {{ parseImages(scope.row.coverImage).length }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="订单号" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="buyerId" label="买家名称" width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="showUserDetail(scope.row.buyerId)">{{ scope.row.buyerNickname }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="sellerId" label="卖家名称" width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="showUserDetail(scope.row.sellerId)">{{ scope.row.sellerNickname }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="productId" label="商品描述" width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="showProductDetail(scope.row.productId)">{{ scope.row.title }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="productAmount" label="商品金额" width="100">
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: 500;">¥{{ scope.row.productAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="shippingFee" label="运费" width="80">
          <template slot-scope="scope">
            <span>¥{{ scope.row.shippingFee || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="订单总额" width="100">
          <template slot-scope="scope">
            <span style="color: #E6A23C; font-weight: 500;">¥{{ scope.row.totalAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payAmount" label="实付金额" width="100">
          <template slot-scope="scope">
            <span style="color: #67C23A; font-weight: 500;">¥{{ scope.row.payAmount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="shippingMethod" label="发货方式" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" type="info">
              {{ getShippingMethodText(scope.row.shippingMethod) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="feeStatus" label="费用状态" width="160">
          <template slot-scope="scope">
            <el-tag :type="getFeeStatusTagType(scope.row.feeStatus)">
              {{ getFeeStatusText(scope.row.feeStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="feeFreeze" label="冻结状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getFreezeTagType(scope.row.feeFreeze)">
              {{ getFreezeText(scope.row.feeFreeze) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="paidAt" label="支付时间" width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.paidAt || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewDetail(scope.row)">详情</el-button>
            <el-button
              type="text"
              size="small"
              v-if="scope.row.status > 1 && scope.row.isOver == 0"
              @click="handleFreeze(scope.row)"
            >
              {{ Number(scope.row.feeFreeze) === 1 ? '解冻' : '冻结' }}
            </el-button>
            <el-button
              v-if="scope.row.feeFreeze === 1 && scope.row.isOver === 0"
              type="text"
              size="small"
              @click="openHandleDialog(scope.row)"
            >待处理</el-button>
            <el-button
              v-if="scope.row.isOver != 0"
              type="text"
              size="small"
            >已处理</el-button>
            <el-button
              type="text"
              size="small"
              v-if="$can('order:ship') && (scope.row.status === 3 || scope.row.status === 5)"
              @click="viewLogistics(scope.row)"
            >
              物流
            </el-button>
            <el-dropdown v-if="$can('order:view')" @command="handleCommand" trigger="click">
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{action: 'updateStatus', row: scope.row}">更新状态</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.status >= 2" :command="{action: 'refund', row: scope.row}">退款处理</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>

    <!-- 订单详情弹窗 -->
    <el-dialog
      title="订单详情"
      :visible.sync="orderDetailVisible"
      width="1100px"
      :before-close="handleClose"
      custom-class="order-detail-dialog">
      <div v-if="orderDetail" class="order-detail-wrapper">
        <div class="order-detail">
          <!-- 订单基本信息卡片 -->
          <div class="detail-card order-header-card">
            <div class="card-header">
              <span class="card-title">基本信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">订单号</span>
                    <span class="item-value">{{ orderDetail.orderNo }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">订单状态</span>
                    <span class="item-value">
                      <el-tag :type="getStatusTagType(orderDetail.status)" size="small">
                        {{ getStatusText(orderDetail.status) }}
                      </el-tag>
                    </span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">创建时间</span>
                    <span class="item-value">{{ orderDetail.createTime }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top: 16px;">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">费用状态</span>
                    <span class="item-value">
                      <el-tag :type="getFeeStatusTagType(orderDetail.feeStatus)" size="small">
                        {{ getFeeStatusText(orderDetail.feeStatus) }}
                      </el-tag>
                    </span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">冻结状态</span>
                    <span class="item-value">
                      <el-tag :type="getFreezeTagType(orderDetail.feeFreeze)" size="small">
                        {{ getFreezeText(orderDetail.feeFreeze) }}
                      </el-tag>
                    </span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 交易信息卡片 -->
          <div class="detail-card">
            <div class="card-header">
              <span class="card-title">交易信息</span>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">买家ID</span>
                    <span class="item-value">{{ orderDetail.buyerId }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">卖家ID</span>
                    <span class="item-value">{{ orderDetail.sellerId }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">商品ID</span>
                    <span class="item-value">{{ orderDetail.productId }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top: 16px;">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">发货方式</span>
                    <span class="item-value">{{ getShippingMethodText(orderDetail.shippingMethod) }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">支付流水</span>
                    <span class="item-value">{{ orderDetail.payNo || '--' }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="item-label">买家留言</span>
                    <span class="item-value">{{ orderDetail.buyerMessage || '--' }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 收货地址卡片 -->
          <div class="detail-card" v-if="orderDetail.addressSnapshot">
            <div class="card-header">
              <span class="card-title">收货地址</span>
            </div>
            <div class="card-body">
              <div class="address-info">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">收货人</span>
                      <span class="item-value">{{ getAddressInfo(orderDetail.addressSnapshot, 'receiverName') }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">联系电话</span>
                      <span class="item-value">{{ getAddressInfo(orderDetail.addressSnapshot, 'receiverPhone') }}</span>
                    </div>
                  </el-col>
                </el-row>
                <div class="detail-item" style="margin-top: 16px;">
                  <span class="item-label">收货地址</span>
                  <span class="item-value">
                    {{ getAddressInfo(orderDetail.addressSnapshot, 'province') }}
                    {{ getAddressInfo(orderDetail.addressSnapshot, 'city') }}
                    {{ getAddressInfo(orderDetail.addressSnapshot, 'district') }}
                    {{ getAddressInfo(orderDetail.addressSnapshot, 'detailAddress') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- 商品信息卡片 -->
          <div class="detail-card" v-if="orderDetail.productSnapshot">
            <div class="card-header">
              <span class="card-title">商品信息</span>
            </div>
            <div class="card-body">
              <div class="product-info">
                <div class="product-info-layout">
                  <div class="product-image-wrapper">
                    <el-image
                      v-if="getProductInfo(orderDetail.productSnapshot, 'coverImage')"
                      :src="getProductInfo(orderDetail.productSnapshot, 'coverImage').split(';')[0]"
                      class="product-image"
                      fit="cover"
                      :preview-src-list="[getProductInfo(orderDetail.productSnapshot, 'coverImage').split(';')[0]]"
                    />
                  </div>
                  <div class="product-details">
                    <div class="product-title">{{ getProductInfo(orderDetail.productSnapshot, 'title') }}</div>
                    <div class="product-meta">
                      <div class="meta-item">
                        <span class="meta-label">商品ID</span>
                        <span class="meta-value">{{ getProductInfo(orderDetail.productSnapshot, 'id') }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">原价</span>
                        <span class="meta-value price-original">¥{{ getProductInfo(orderDetail.productSnapshot, 'originalPrice') }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">售价</span>
                        <span class="meta-value price-sale">{{ (getProductInfo(orderDetail.productSnapshot, 'price') !== null && getProductInfo(orderDetail.productSnapshot, 'price') !== undefined && getProductInfo(orderDetail.productSnapshot, 'price') !== '' && Number(getProductInfo(orderDetail.productSnapshot, 'price')) === 0) ? '价格线聊' : '¥' + (getProductInfo(orderDetail.productSnapshot, 'price') == null ? '' : getProductInfo(orderDetail.productSnapshot, 'price')) }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">地区</span>
                        <span class="meta-value">
                          {{ getProductInfo(orderDetail.productSnapshot, 'province') }}
                          {{ getProductInfo(orderDetail.productSnapshot, 'city') }}
                          {{ getProductInfo(orderDetail.productSnapshot, 'district') }}
                        </span>
                      </div>
                    </div>
                    <div class="product-desc-section">
                      <span class="desc-label">商品描述</span>
                      <div class="product-description">
                        {{ getProductInfo(orderDetail.productSnapshot, 'description') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 费用信息卡片 -->
          <div class="detail-card">
            <div class="card-header">
              <span class="card-title">费用信息</span>
            </div>
            <div class="card-body">
              <div class="price-info">
                <el-row :gutter="16">
                  <el-col :span="6">
                    <div class="price-item">
                      <div class="price-label">商品金额</div>
                      <div class="price-value">¥{{ orderDetail.productAmount }}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="price-item">
                      <div class="price-label">运费</div>
                      <div class="price-value">¥{{ orderDetail.shippingFee || 0 }}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="price-item">
                      <div class="price-label">订单总额</div>
                      <div class="price-value">¥{{ orderDetail.totalAmount }}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="price-item price-item-highlight">
                      <div class="price-label">实付金额</div>
                      <div class="price-value">¥{{ orderDetail.payAmount }}</div>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 20px;">
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">支付超时</span>
                      <span class="item-value">{{ orderDetail.payExpireTime || '--' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">支付时间</span>
                      <span class="item-value">{{ orderDetail.paidAt || '--' }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 16px;">
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">发货时间</span>
                      <span class="item-value">{{ orderDetail.shippedAt || '--' }}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="detail-item">
                      <span class="item-label">收货时间</span>
                      <span class="item-value">{{ orderDetail.receivedAt || '--' }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>

          <!-- 物流信息卡片 -->
          <div class="detail-card" v-if="orderDetail.logistics">
            <div class="card-header">
              <span class="card-title">物流信息</span>
            </div>
            <div class="card-body">
              <div class="logistics-info">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="detail-item">
                      <span class="item-label">物流公司</span>
                      <span class="item-value">{{ orderDetail.logistics.companyName }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="detail-item">
                      <span class="item-label">运单号</span>
                      <span class="item-value">{{ orderDetail.logistics.trackingNo }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="detail-item">
                      <span class="item-label">物流状态</span>
                      <span class="item-value">{{ orderDetail.logistics.status }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 发货弹窗 -->
    <el-dialog
      title="订单发货"
      :visible.sync="shipDialogVisible"
      width="500px">
      <el-form :model="shipForm" :rules="shipRules" ref="shipForm" label-width="100px">
        <el-form-item label="物流公司" prop="logisticsCompany">
          <el-input v-model="shipForm.logisticsCompany" placeholder="请输入物流公司"></el-input>
        </el-form-item>
        <el-form-item label="运单号" prop="trackingNo">
          <el-input v-model="shipForm.trackingNo" placeholder="请输入运单号"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="shipForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入发货备注"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="shipDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitShip" :loading="shipping">确定发货</el-button>
      </div>
    </el-dialog>

    <!-- 更新状态弹窗 -->
    <el-dialog
      title="更新订单状态"
      :visible.sync="statusDialogVisible"
      width="400px">
      <el-form :model="statusForm" label-width="80px">
        <el-form-item label="订单状态">
          <el-select v-model="statusForm.status" placeholder="请选择状态" style="width: 100%;">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="statusForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statusDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitStatusUpdate">确定</el-button>
      </div>
    </el-dialog>

    <!-- 处理诉讼弹窗 -->
    <el-dialog
      title="处理诉讼"
      :visible.sync="handleDialog.visible"
      width="480px"
      :close-on-click-modal="false"
      @closed="resetHandleForm">
      <el-form :model="handleForm" :rules="handleRules" ref="handleFormRef" label-width="90px" size="small">
        <el-form-item label="订单号">
          <span class="dialog-text">{{ handleDialog.row && handleDialog.row.orderNo }}</span>
        </el-form-item>
        <el-form-item label="处理方式" prop="status">
          <el-select v-model="handleForm.status" placeholder="请选择处理方式" style="width: 100%;">
            <el-option label="给卖方转账" :value="3"></el-option>
            <el-option label="给买方退款" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理备注" prop="handleRemark">
          <el-input
            v-model="handleForm.handleRemark"
            type="textarea"
            :rows="4"
            placeholder="请输入处理备注"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="handleDialog.visible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="handleDialog.submitting" @click="submitHandle">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 用户详情对话框 -->
    <user-detail-dialog
      :visible.sync="userDetailVisible"
      :user-id="selectedUserId">
    </user-detail-dialog>

    <!-- 商品详情对话框 -->
    <product-detail-dialog
      :visible.sync="productDetailVisible"
      :product-id="selectedProductId">
    </product-detail-dialog>

  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import UserDetailDialog from '../common/user-detail-dialog.vue';
  import ProductDetailDialog from '../common/product-detail-dialog.vue';

  export default {
    name: "order-stat",
    components: {
      UserDetailDialog,
      ProductDetailDialog
    },
    data () {
      return {
        // 统计数据
        statistics: {
          totalOrders: 0,
          paidOrders: 0,
          totalAmount: 0,
          paidAmount: 0
        },
        // 表格数据
        total: 0,
        tableData: [],
        searchDateArr: [],
        loading: false,
        currentPage: 1,
        shipping: false,
        // 弹窗控制
        orderDetailVisible: false,
        shipDialogVisible: false,
        statusDialogVisible: false,
        orderDetail: null,
        currentOrder: null,
        // 发货表单
        shipForm: {
          id: null,
          logisticsCompany: '',
          trackingNo: '',
          remark: ''
        },
        // 状态更新表单
        statusForm: {
          id: null,
          status: '',
          remark: ''
        },
        handleDialog: {
          visible: false,
          row: null,
          submitting: false
        },
        handleForm: {
          status: '',
          handleRemark: ''
        },
        handleRules: {
          status: [{ required: true, message: '请选择处理状态', trigger: 'change' }],
          handleRemark: [{ required: true, message: '请输入处理备注', trigger: 'blur' }]
        },
        // 用户详情弹窗
        userDetailVisible: false,
        selectedUserId: null,
        // 商品详情弹窗
        productDetailVisible: false,
        selectedProductId: null,
        // 搜索条件
        searchInfo: {
          orderNo: '',
          status: '',
          buyerId: '',
          sellerId: '',
          productId: '',
          startDate: '',
          endDate: '',
          pageNumber: 1,
          pageSize: 20,
        },
        // 下拉列表数据
        statusList: [
          { label: '待支付', value: 1 },
          { label: '待发货', value: 2 },
          { label: '待收货', value: 3 },
          { label: '已完成', value: 5 },
          { label: '已取消', value: 6 },
          { label: '退款中', value: 7 },
          { label: '退货中', value: 8 },
          { label: '已退款', value: 9 },
          { label: '退货退货', value: 10 },
          { label: '已完结（转给卖家）', value: 11 }
        ],
        // 表单验证规则
        shipRules: {
          logisticsCompany: [
            { required: true, message: '请输入物流公司', trigger: 'blur' }
          ],
          trackingNo: [
            { required: true, message: '请输入运单号', trigger: 'blur' }
          ]
        },
        // 日期选择器配置
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    watch: {
      'searchInfo.orderNo'(newVal){
        if (newVal === ""){
          this.getOrderList();
        }
      },
      'searchInfo.buyerId'(newVal){
        if (newVal === ""){
          this.getOrderList();
        }
      },
      'searchInfo.sellerId'(newVal){
        if (newVal === ""){
          this.getOrderList();
        }
      },
      'searchInfo.productId'(newVal){
        if (newVal === ""){
          this.getOrderList();
        }
      },
      'searchDateArr'(newVal){
        if (newVal === null){
          this.searchInfo.startDate = "";
          this.searchInfo.endDate = "";
          this.getOrderList();
        }
      },
    },
    created() {
      this.getOrderList();
      this.getStatistics();
    },
    methods: {
      // 显示用户详情
      showUserDetail(userId) {
        this.selectedUserId = userId;
        this.userDetailVisible = true;
      },

      // 显示商品详情
      showProductDetail(productId) {
        this.selectedProductId = productId;
        this.productDetailVisible = true;
      },

      // 搜索
      search() {
        this.currentPage = 1;
        this.searchInfo.pageNumber = 1;
        this.getOrderList();
      },

      // 刷新统计数据
      refreshStats() {
        this.getStatistics();
      },

      // 分页处理
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val;
        this.getOrderList();
      },

      handleSizeChange(val) {
        this.currentPage = 1;
        this.searchInfo.pageSize = val;
        this.searchInfo.pageNumber = 1;
        this.getOrderList();
      },
      // 解析图片URL（分号分隔）
      parseImages(coverImage) {
        if (!coverImage) return [];
        // 分号分隔，过滤空字符串
        return coverImage.split(';').filter(img => img.trim());
      },

      // 获取订单列表
      getOrderList() {
        if (this.searchDateArr && this.searchDateArr.length === 2) {
          this.searchInfo.startDate = this.searchDateArr[0];
          this.searchInfo.endDate = this.searchDateArr[1];
        }

        if (this.loading) return;
        this.loading = true;

        axios.get('/admin/order/list', {
          params: this.searchInfo
        }).then(result => {
          this.loading = false;
          if (result.code === 200) {
            this.total = result.data.total;
            this.tableData = result.data.list;
          } else {
            this.$message.error(result.message || '获取数据失败');
          }
        }).catch(err => {
          console.error(err);
          this.loading = false;
          this.$message.error('网络异常，请重试');
        });
      },

      // 获取统计数据
      getStatistics() {
        axios.get('/admin/order/statistics', {
          params: { period: 'month' }
        }).then(result => {
          if (result.code === 200) {
            this.statistics = result.data;
          }
        }).catch(err => {
          console.error('获取统计数据失败:', err);
        });
      },

      // 查看订单详情
      viewDetail(row) {
        this.getOrderDetail(row.id);
      },

      // 获取订单详情
      getOrderDetail(id) {
        axios.get(`/admin/order/${id}`).then(result => {
          if (result.code === 200) {
            this.orderDetail = result.data;
            this.orderDetailVisible = true;
          } else {
            this.$message.error('获取订单详情失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 显示发货弹窗
      showShipDialog(row) {
        this.currentOrder = row;
        this.shipForm = {
          id: row.id,
          logisticsCompany: '',
          trackingNo: '',
          remark: ''
        };
        this.shipDialogVisible = true;
      },

      // 提交发货
      submitShip() {
        this.$refs.shipForm.validate((valid) => {
          if (valid) {
            this.shipping = true;
            axios.post(`/admin/order/${this.shipForm.id}/ship`, {
              logisticsCompany: this.shipForm.logisticsCompany,
              trackingNo: this.shipForm.trackingNo,
              remark: this.shipForm.remark
            }).then(result => {
              this.shipping = false;
              if (result.code === 200) {
                this.$message.success('发货成功');
                this.shipDialogVisible = false;
                this.getOrderList();
                this.getStatistics();
              } else {
                this.$message.error(result.message || '发货失败');
              }
            }).catch(err => {
              console.error(err);
              this.shipping = false;
              this.$message.error('网络异常，请重试');
            });
          }
        });
      },

      // 查看物流信息
      viewLogistics(row) {
        // 这里可以打开物流跟踪弹窗或跳转到物流详情页面
        this.$message.info('物流跟踪功能开发中...');
      },

      // 下拉菜单命令处理
      handleCommand(command) {
        const { action, row } = command;
        if (action === 'updateStatus') {
          this.showStatusDialog(row);
        } else if (action === 'refund') {
          this.handleRefund(row);
        }
      },

      // 显示状态更新弹窗
      showStatusDialog(row) {
        this.currentOrder = row;
        this.statusForm = {
          id: row.id,
          status: row.status,
          remark: ''
        };
        this.statusDialogVisible = true;
      },

      // 提交状态更新
      submitStatusUpdate() {
        axios.put(`/admin/order/${this.statusForm.id}/status`, {
          status: this.statusForm.status,
          remark: this.statusForm.remark
        }).then(result => {
          if (result.code === 200) {
            this.$message.success('状态更新成功');
            this.statusDialogVisible = false;
            this.getOrderList();
            this.getStatistics();
          } else {
            this.$message.error(result.message || '状态更新失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      isFrozenOrder(row) {
        return Number(row.feeFreeze) === 1;
      },

      getLitigationStatus(row) {
        if (row.litigationStatus !== undefined && row.litigationStatus !== null) {
          return Number(row.litigationStatus);
        }
        return Number(row.status);
      },

      isLitigationPending(row) {
        return this.getLitigationStatus(row) === 1;
      },

      openHandleDialog(row) {
        this.handleDialog.row = row;
        this.handleForm.status = '';
        this.handleForm.handleRemark = row.handleRemark || '';
        this.handleDialog.visible = true;
      },

      resetHandleForm() {
        this.handleForm = {
          status: '',
          handleRemark: ''
        };
        this.handleDialog.row = null;
        if (this.$refs.handleFormRef) {
          this.$refs.handleFormRef.clearValidate();
        }
      },

      submitHandle() {
        this.$refs.handleFormRef.validate(valid => {
          if (!valid) return;

          const row = this.handleDialog.row;
          if (!row) return;

          this.handleDialog.submitting = true;
          axios.post('admin/order/litigation/handle', {
            status: this.handleForm.status,
            handleRemark: this.handleForm.handleRemark,
            litigationNo: row.litigationNo,
            orderNo: row.orderNo
          }, {
            headers: { 'Content-Type': 'application/json' },
            transformRequest: [(data) => JSON.stringify(data)]
          }).then(result => {
            if (result.code === 200) {
              this.$message.success('处理成功');
              this.handleDialog.visible = false;
              this.getOrderList();
              this.getStatistics();
            } else {
              this.$message.error(result.message || '处理失败');
            }
          }).catch(err => {
            console.error(err);
            this.$message.error('请求失败，请稍后重试');
          }).finally(() => {
            this.handleDialog.submitting = false;
          });
        });
      },

      // 冻结/解冻订单
      handleFreeze(row) {
        const targetStatus = Number(row.feeFreeze) === 1 ? 0 : 1;
        const actionText = targetStatus === 1 ? '冻结' : '解冻';

        // 冻结前校验退货状态：只有 returnStatus=4（已退货）才允许冻结
        if (targetStatus === 1 && Number(row.returnStatus) !== 4) {
          this.$message.warning('只有退货流程走完，才可以进行冻结');
          return;
        }

        this.$confirm(`确定要${actionText}订单"${row.orderNo}"吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.put('/admin/order/freeze', null, {
            params: {
              orderNo: row.orderNo,
              status: targetStatus
            }
          }).then(result => {
            if (result.code === 200) {
              this.$message.success(`${actionText}成功`);
              this.getOrderList();
              this.getStatistics();
            } else {
              this.$message.error(result.message || `${actionText}失败`);
            }
          }).catch(err => {
            console.error(err);
            this.$message.error('网络异常，请重试');
          });
        }).catch(() => {
          this.$message.info(`已取消${actionText}`);
        });
      },

      // 处理退款
      handleRefund(row) {
        this.$confirm(`确定要为订单"${row.orderNo}"申请退款吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 这里调用退款接口
          this.$message.info('退款功能开发中...');
        }).catch(() => {
          this.$message.info('已取消退款');
        });
      },

      // 双击行事件
      handleRowDblClick(row) {
        this.viewDetail(row);
      },

      // 关闭弹窗
      handleClose(done) {
        this.orderDetail = null;
        done();
      },

      // 工具方法
      formatAmount(amount) {
        if (!amount) return '¥0';
        if (amount >= 10000) {
          return '¥' + (amount / 10000).toFixed(1) + '万';
        }
        return '¥' + amount.toLocaleString();
      },

      getStatusText(status) {
        const statusMap = {
          1: '待支付',
          2: '待发货',
          3: '待收货',
          5: '已完成',
          6: '已取消',
          7: '退款中',
          8: '退货中',
          9: '已退款',
          10: '退货退货',
          11: '已完结（转给卖家）'
        };
        return statusMap[status] || '未知';
      },

      getStatusTagType(status) {
        const typeMap = {
          1: 'warning',
          2: 'primary',
          3: 'info',
          5: 'success',
          6: 'danger',
          7: 'warning',
          8: 'warning',
          9: 'danger',
          10: 'danger',
          11: 'success'
        };
        return typeMap[status] || 'info';
      },

      getFeeStatusText(feeStatus) {
        const feeStatusMap = {
          0: '在企业账户',
          1: '倒计时打款到卖方账户',
          2: '在企业账户（申请退货）',
          3: '倒计时退回买方账户',
          4: '已到卖方账户',
          5: '退回原来账户'
        };
        return feeStatusMap[feeStatus] || '未知';
      },

      getFeeStatusTagType(feeStatus) {
        const typeMap = {
          0: 'info',
          1: 'warning',
          2: 'warning',
          3: 'warning',
          4: 'success',
          5: 'danger'
        };
        return typeMap[feeStatus] || 'info';
      },

      getFreezeText(feeFreeze) {
        const freezeMap = {
          0: '正常',
          1: '已冻结'
        };
        return freezeMap[feeFreeze] || '未知';
      },

      getFreezeTagType(feeFreeze) {
        const typeMap = {
          0: 'success',
          1: 'danger'
        };
        return typeMap[feeFreeze] || 'info';
      },

      getShippingMethodText(shippingMethod) {
        const shippingMethodMap = {
          1: '邮寄',
          2: '面交'
        };
        return shippingMethodMap[shippingMethod] || '未知';
      },

      // 解析商品快照数据
      getProductInfo(productSnapshot, field) {
        try {
          if (typeof productSnapshot === 'string') {
            const product = JSON.parse(productSnapshot);
            return product[field] || '';
          } else if (typeof productSnapshot === 'object' && productSnapshot !== null) {
            return productSnapshot[field] || '';
          }
          return '';
        } catch (e) {
          console.error('解析商品快照失败:', e);
          return '';
        }
      },

      // 解析地址快照数据
      getAddressInfo(addressSnapshot, field) {
        try {
          if (typeof addressSnapshot === 'string') {
            const address = JSON.parse(addressSnapshot);
            return address[field] || '';
          } else if (typeof addressSnapshot === 'object' && addressSnapshot !== null) {
            return addressSnapshot[field] || '';
          }
          return '';
        } catch (e) {
          console.error('解析地址快照失败:', e);
          return '';
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .order-stat {
    .stats-cards {
      margin-bottom: 20px;

      .el-col {
        min-width: 280px;
        margin-top: 30px;
      }

      .stats-card {
        background: #fff;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        min-width: 260px;
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
        }

        .stats-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
          margin-right: 16px;
          flex-shrink: 0;

          &.total {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }
          &.paid {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          }
          &.amount {
            background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
          }
          &.paid-amount {
            background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
          }
        }

        .stats-content {
          flex: 1;
          min-width: 0;

          .stats-number {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            line-height: 1.2;
            word-break: break-all;
          }
          .stats-label {
            font-size: 14px;
            color: #666;
            margin-top: 4px;
            white-space: nowrap;
          }
        }
      }
    }
  }

  // 订单详情弹窗样式
  /deep/ .order-detail-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #e8eaec;
      padding: 20px 24px;

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
      }
    }

    .el-dialog__body {
      padding: 0;
      background: #f5f7fa;
    }
  }

  .order-detail-wrapper {
    padding: 20px;
  }

  .order-detail {
    // 卡片基础样式
    .detail-card {
      background: #fff;
      border-radius: 8px;
      margin-bottom: 16px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
      overflow: hidden;

      &:last-child {
        margin-bottom: 0;
      }

      .card-header {
        padding: 16px 20px;
        background: linear-gradient(90deg, #f7f8fa 0%, #fff 100%);
        border-bottom: 1px solid #ebeef5;

        .card-title {
          font-size: 15px;
          font-weight: 600;
          color: #303133;
          position: relative;
          padding-left: 12px;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 16px;
            background: #409EFF;
            border-radius: 2px;
          }
        }
      }

      .card-body {
        padding: 20px;
      }
    }

    // 详情项样式
    .detail-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 0;

      .item-label {
        color: #909399;
        font-size: 14px;
        min-width: 80px;
        margin-right: 12px;
        flex-shrink: 0;
      }

      .item-value {
        color: #303133;
        font-size: 14px;
        flex: 1;
        word-break: break-all;
      }
    }

    // 收货地址样式
    .address-info {
      .detail-item {
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    // 商品信息样式
    .product-info {
      .product-info-layout {
        display: flex;
        gap: 20px;
        align-items: flex-start;
      }

      .product-image-wrapper {
        flex-shrink: 0;
      }

      .product-image {
        width: 120px;
        height: 120px;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        cursor: pointer;
        transition: transform 0.2s;

        &:hover {
          transform: scale(1.02);
        }
      }

      .product-details {
        flex: 1;
        min-width: 0;

        .product-title {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          margin-bottom: 12px;
          line-height: 1.5;
          word-break: break-all;
        }

        .product-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          margin-bottom: 16px;

          .meta-item {
            display: flex;
            align-items: center;
            gap: 8px;

            .meta-label {
              color: #909399;
              font-size: 14px;
              flex-shrink: 0;
            }

            .meta-value {
              color: #303133;
              font-size: 14px;
            }
          }
        }

        .price-original {
          color: #909399;
          text-decoration: line-through;
        }

        .price-sale {
          color: #f56c6c;
          font-weight: 600;
          font-size: 16px;
        }

        .product-desc-section {
          .desc-label {
            display: block;
            color: #909399;
            font-size: 14px;
            margin-bottom: 8px;
          }
        }

        .product-description {
          padding: 12px 16px;
          background: linear-gradient(135deg, #f8f9fa 0%, #f5f7fa 100%);
          border-radius: 8px;
          color: #606266;
          font-size: 13px;
          line-height: 1.8;
          max-height: 150px;
          overflow-y: auto;
          word-break: break-all;

          &::-webkit-scrollbar {
            width: 6px;
          }

          &::-webkit-scrollbar-thumb {
            background: #dcdfe6;
            border-radius: 3px;
          }

          &::-webkit-scrollbar-track {
            background: #f5f7fa;
          }
        }
      }
    }

    // 费用信息样式
    .price-info {
      .price-item {
        text-align: center;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        transition: all 0.3s;

        &:hover {
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
          border-color: #c6e2ff;
        }

        .price-label {
          font-size: 13px;
          color: #909399;
          margin-bottom: 8px;
        }

        .price-value {
          font-size: 20px;
          font-weight: 600;
          color: #303133;
        }

        &.price-item-highlight {
          background: linear-gradient(135deg, #fff6e6 0%, #ffecd0 100%);
          border-color: #ffd591;

          .price-value {
            color: #e6a23c;
            font-size: 24px;
          }
        }
      }

      .detail-item {
        margin-bottom: 0;
      }
    }

    // 物流信息样式
    .logistics-info {
      .detail-item {
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          &.date-picker {
            .el-date-editor {
              width: 280px !important;
              /deep/ .el-input__inner {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .search-btn {
      padding-top: 0;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
        margin-left: 8px;
      }
    }
  }

  .tableStyle {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
    font-size: 12px;
  }

  @media screen and (max-width: 992px) {
    .order-stat .stats-cards {
      .el-col {
        min-width: 45%;
        margin-bottom: 20px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }

    .order-stat .stats-cards {
      .el-col {
        margin-bottom: 16px;
        min-width: 100%;
      }

      .stats-card {
        min-width: auto;
      }
    }

    .order-detail-wrapper {
      padding: 12px;
    }

    .order-detail {
      .detail-card {
        .card-body {
          padding: 16px;
        }
      }

      .detail-item {
        flex-direction: column;
        align-items: flex-start;

        .item-label {
          margin-bottom: 4px;
        }
      }

      .price-info {
        .el-col {
          margin-bottom: 12px;
        }

        .price-item {
          padding: 12px;

          .price-value {
            font-size: 18px;
          }

          &.price-item-highlight .price-value {
            font-size: 20px;
          }
        }
      }

      .product-info {
        .product-info-layout {
          flex-direction: column;
        }

        .product-image {
          width: 100px;
          height: 100px;
        }

        .product-meta {
          gap: 12px;

          .meta-item {
            width: 100%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 480px) {
    .order-stat .stats-cards {
      .stats-card {
        padding: 16px;

        .stats-icon {
          width: 50px;
          height: 50px;
          font-size: 20px;
          margin-right: 12px;
        }

        .stats-content {
          .stats-number {
            font-size: 20px;
          }
          .stats-label {
            font-size: 12px;
          }
        }
      }
    }
  }

  /deep/ .el-date-editor .el-range-separator {
    color: #606266 !important;
  }

  /deep/ .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
  }

  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  /deep/ .el-divider__text {
    background: #fff;
    font-weight: 500;
    color: #303133;
  }

  /deep/ .el-table .warning-row {
    background: #fdf6ec;
  }

  /deep/ .el-table .success-row {
    background: #f0f9ff;
  }
</style>
